// extracted by mini-css-extract-plugin
export default {"container":"about_container__rB6lK","container__title":"about_container__title__f1GIQ","container__text":"about_container__text__kdQzC"};